import { render, staticRenderFns } from "./InfoVrtTrans.vue?vue&type=template&id=82da11f8&scoped=true"
import script from "./InfoVrtTrans.vue?vue&type=script&lang=js"
export * from "./InfoVrtTrans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82da11f8",
  null
  
)

export default component.exports